module.exports = require("@swa-ui/placements/src/PlacementFactory/PlacementFactory.module.scss");